import { coerceInt } from '@synapex/tools/utils';
export const REFERRER_SEARCH_PARAM_KEY = 'referrer';
export const addReferrer = (searchParams, { user_id, }) => {
    searchParams.append(REFERRER_SEARCH_PARAM_KEY, user_id.toString());
    return searchParams;
};
export const getReferrer = (searchParams) => {
    const r = searchParams.get(REFERRER_SEARCH_PARAM_KEY);
    if (r) {
        const user_id = coerceInt(r);
        if (user_id) {
            return {
                user_id,
            };
        }
    }
    return null;
};
//# sourceMappingURL=referral.js.map